import styled from 'styled-components';
import { BaSeTheme } from '@base/react';

export const FooterButton = styled.div`
  display: grid;
  width: 100%;
  margin: 34px 0;
  place-items: center;
  @media screen and (max-width: ${BaSeTheme.breakpoints.tablet.maxWidth}px) {
    place-items: initial;
  }
`;

export const ContentContainer = styled.div`
  margin: 42px 0;
  @media print {
    margin-top: 0;
  }
`;

export const NoPrint = styled.div`
  @media print {
    display: none;
  }
`;

export const ActivatedFilters = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
`;

export const WrapperActivatedFilters = styled.div`
  display: ${({ isMobile }) => (isMobile ? 'grid' : 'flex')};
  gap: 10px;
`;

export const ButtonOptionPicker = styled.div`
  position: absolute;
  z-index: 6;
  background: white;
  border: 1px solid #b6bfc8;
  border-radius: 5px;
  padding: 10px;
  display: grid;
  gap: 10px;
  right: ${({ isMobile }) => (isMobile ? '23px' : 'auto')};
`;

export const WrapperFilters = styled.div`
  display: grid;
  gap: 10px;
  margin-top: 16px;
`;

export const WrapperContentInput = styled.div`
  display: grid;
  gap: 24px;
  margin: 24px 0;
`;

export const WrapperActions = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 24px;
`;

export const WrapperContentFilters = styled.div`
  display: flex;
  gap: 10px;
`;
